<template>
  <div>
    <v-dialog v-model="show" persistent width="310px">
      <v-card>
        <v-app-bar text color="secondary">
          <page-header-title class="headline" :title="page_title"></page-header-title>
        </v-app-bar>

        <v-card-text class="py-0 mt-4">
          <v-row justify="center">
            <v-col :cols="12" class="text-center ma-0 pa-0">
              <v-text-field
                xs12
                v-model="entered_pin"
                type="password"
                class="pin-input"
                :label="$t('settings.digit_pin')"
                readonly
                autocomplete="new-password"
              ></v-text-field>
            </v-col>

            <v-col v-for="k in 9" :key="k" :cols="4" class="text-center ma-0 my-2 pa-0">
              <v-btn color="primary" fab outlined @click="digit(k)" class="darken-2">
                {{ k }}
              </v-btn>
            </v-col>

            <v-col :cols="4" class="text-center ma-0 my-2 pa-0">
              <v-btn color="primary" fab outlined @click="digit(0)" class="darken-2">
                0
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pa-3 mt-3">
          <action-button type="reset" xs6 block @click="reset" />
          <action-button type="back" xs6 block @click="cancel" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "PinCodePopup",

  props: {
    show: {
      type: Boolean,
      required: true
    },
    verify_currentpin: {
      type: Boolean
    }
  },

  data() {
    return {
      page_title: "",

      entered_pin: "",
      prev_entered_pin: "",
      current_pinObj: {},

      verified: false
    }
  },

  created() {
    let vm = this

    this.$store.dispatch("auth/getPinCode").then((result) => {
      if (vm.verify_currentpin && result) {
        vm.page_title = vm.$t("auth.currentpincode_title")
        vm.current_pinObj = result
      } else {
        if (result) {
          vm.page_title = vm.$t("auth.pincode_title")
        } else {
          vm.page_title = vm.$t("auth.newpincode_title")
        }
      }
    })
  },

  watch: {
    show: {
      handler() {
        this.reset()
      }
    }
  },

  methods: {
    digit(i) {
      let vm = this

      this.entered_pin = this.entered_pin.concat(i)

      if (this.entered_pin.length == 4) {
        if (!_.isEmpty(this.current_pinObj) && this.verify_currentpin && !this.verified) {
          this.verify()
        } else {
          if (this.entered_pin && this.prev_entered_pin) {
            this.submit()
          } else {
            this.reenter()
          }
        }
      }
    },
    submit() {
      let entered_pin = this.entered_pin
      let prev_entered_pin = this.prev_entered_pin

      this.entered_pin = ""

      if (entered_pin == prev_entered_pin) {
        this.prev_entered_pin = ""

        this.$awn.success(this.$t("auth.success_pincode"))
        this.$emit("callback_pincode_submit", entered_pin)
      } else {
        this.$awn.alert(this.$t("auth.mismatch_pincode"))
      }
    },
    reenter() {
      this.page_title = this.$t("auth.reenter_pincode_title")

      this.prev_entered_pin = this.entered_pin
      this.entered_pin = ""
    },
    verify() {
      let vm = this

      this.bcrypt.compare(this.entered_pin, this.current_pinObj.hash, (err, res) => {
        if (res) {
          vm.verified = true
          vm.page_title = vm.$t("auth.newpincode_title")
        } else {
          vm.$awn.alert(vm.$t("auth.invalid_pincode"))
        }

        vm.reset()
      })
    },
    cancel() {
      this.entered_pin = ""
      this.$emit("callback_pincode_cancel")
    },
    reset() {
      this.entered_pin = ""
    }
  }
}
</script>

<style scoped>
.pin-input >>> input {
  text-align: center;
  font-size: 3em;
  font-weight: bold;
  letter-spacing: 0.5em;
  padding-left: 0.5em;
}
</style>
